define('appkit/resource.service',['require','exports','module','backbone.radio','underscore'],function(require, exports, module) {
  var Radio = require('backbone.radio');
  var _     = require('underscore');


  var ResourceService = {

    channelName: 'AppKit.resourceService',

    resourceRegistry: {},

    radioRequests: {
      'registerResource'   : 'registerResource',
      'deregisterResource' : 'deregisterResource',
      'resetRegistry'      : 'resetRegistry',
      'hasResource'        : 'hasResource',
      'resource'           : 'getResource'
    },

    getResource: function(resourcePath) {
      var parts = String(resourcePath == null ? '' : resourcePath).split('.');
      var resourceName = _.first(parts);
      var dataPath = _.rest(parts).join('.');
      var resource = _.result(this.resourceRegistry[resourceName], 'resource');

      if (resource && dataPath) {
        return resource.get(dataPath);
      }
      return resource;
    },

    hasResource: function(name) {
      return _.has(this.resourceRegistry, name);
    },

    registerResource: function(name, resource, options) {
      options = _.extend({}, options, {
        resourceName: name
      });
      this.resourceRegistry[name] = {
        resource: resource,
        options: options
      };
      Radio.trigger(this.channelName, 'register:' + name, resource, options);
      Radio.trigger(this.channelName, 'register', resource, options);
      return resource;
    },

    deregisterResource: function(name, options) {
      var resource;
      options = _.extend({}, options, {
        resourceName: name
      });
      if (_.has(this.resourceRegistry, name)) {
        var resourceEntry = this.resourceRegistry[name];
        if (options.owner && options.owner !== resourceEntry.options.owner) {
          // if the register owner does not equal the passed in owner
          // then don't do anything!
          return;
        }
        resource = _.result(resourceEntry, 'resource');
        delete this.resourceRegistry[name];
        Radio.trigger(this.channelName, 'deregister:' + name, resource, options);
        Radio.trigger(this.channelName, 'deregister', resource, options);
      }
      return resource;
    },

    resetRegistry: function() {
      this.resourceRegistry = {};
    }

  };

  module.exports = ResourceService;
});
